


















































































module.exports =
  name: 'form_tooltips'
  props:
    type:
      type: String
      required: true
  methods:
    showPlanningModal: -> @$store.dispatch('showPlanningModal')
